import { odooApi } from '../index';
import { Delegation } from '@/types';
import { getOdooLang } from '@/config/api.config';
import { extractErrorMessage } from '../transforms';

/**
 * Delegations API Endpoints (Connected to Odoo Backend)
 * 
 * This file contains all delegation-related API endpoints.
 * Connected to real Odoo API at /api/moys/delegations
 */

export const delegationsApi = odooApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get all delegations from Odoo
    getDelegations: builder.query<Delegation[], { lang?: 'ar' | 'en' | 'ku' } | void>({
      query: (arg) => {
        const odooLang = getOdooLang(arg?.lang || 'ar');
        
        return {
          url: `/api/moys/delegations?lang=${odooLang}`,
          method: 'POST',
        };
      },
      transformResponse: (response: any) => {
        try {
          if (!response.success || !response.data) {
            throw new Error('Invalid response format');
          }
          
          return response.data.map((item: any) => ({
            id: String(item.id),
            // Map backend fields to Delegation type used in UI
            officialName: item.name || item.responsible_person_id || '',
            position: item.position_id || item.position || '',
            destination: item.city || '',
            country: item.city || '',
            startDate: item.start_date || new Date().toISOString(),
            endDate: item.end_date || new Date().toISOString(),
            purpose: {
              ar: item.purpose || '',
              en: item.purpose || '',
              ku: item.purpose || '',
            },
            departmentId: '',
            image: item.image || undefined,
            isPublished: item.is_published !== undefined ? item.is_published : true,
            responsiblePerson: item.responsible_person_id || undefined,
          })) as Delegation[];
        } catch (error) {
          console.error('[Delegations API] Transform error:', error);
          throw error;
        }
      },
      transformErrorResponse: (response) => {
        return extractErrorMessage(response);
      },
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ id }) => ({ type: 'Delegation' as const, id })),
              { type: 'Delegation', id: 'LIST' },
            ]
          : [{ type: 'Delegation', id: 'LIST' }],
    }),
  }),
});

export const {
  useGetDelegationsQuery,
} = delegationsApi;
